<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <span slot="header">搜索</span>

      <el-form :model="search"
               ref="searchForm"
               :rules="searchRules"
               label-width="110px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item prop="userid"
                        label="用户ID">
            <el-input v-model="search.userid" clearable />
          </el-form-item>
          <el-form-item prop="update_start"
                        label="开始时间:">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="search.starttime"
              type="datetime"
              clearable
              align="center" />
          </el-form-item>
          <el-form-item prop="update_end"
                        label="结束时间:">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="search.endtime"
              type="datetime"
              clearable
              align="center" />
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel :show-header="false"
                  class="table-panel">
      <el-button type="primary"
                 size="mini"
                 @click="onGenExcel()">生成报表
      </el-button>
      <el-button type="danger"
                 size="mini"
                 @click="batchCancelWithdraw()">批量驳回
      </el-button>
    </layout-panel>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                @selection-change="handleSelectionChange"
                @sort-change="sortChange"
                @select-all="setSelectAll">
        <el-table-column
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column prop="userid"
                         label="用户ID"
                         sortable="custom">
          <template slot-scope="scope">
            <router-link :to="'/users/detail/info?userid='+ scope.row.userid">
              <span>{{scope.row.userid}}</span>
            </router-link>
          </template>
        </el-table-column>

        <el-table-column prop="realname"
                         label="姓名"></el-table-column>

        <el-table-column prop="balance"
                         label="可提现额度"
                         sortable></el-table-column>

        <el-table-column prop="frozenbalance"
                         label="冻结额度"
                         sortable></el-table-column>

        <el-table-column prop="totalwithdraw"
                         label="已提现额度"
                         sortable></el-table-column>

        <el-table-column fixed="right"
                         label="操作"
                         width="350">
          <template slot-scope="scope">
            <el-button
                 size="mini"
                 type="danger"
                 @click="cancelWithdrawData(scope.row.userid)">驳回所有提现请求
            </el-button>
            <el-button
                size="mini"
                @click="getWithdrawDetail(scope.row.userid)">查看提现记录
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <el-dialog title="提现记录"
               :visible.sync="dialogWithdrawTableVisible"
               width="80%"
               :center="true">
      <el-table :data="batchDetailTable"
                stripe
                highlight-current-row
                height="500">
        <el-table-column prop="id"
                         label="id"></el-table-column>
        <el-table-column prop="flowid"
                         label="流水号"></el-table-column>
        <el-table-column prop="credit"
                         label="提现金额"></el-table-column>
        <el-table-column prop="updatetime"
                         label="提现时间"></el-table-column>
        <el-table-column prop="withdrawtype"
                         label="提现方式">
          <template slot-scope="scope">
          <span v-for="item in options.withdrawtype"
                v-if="scope.row.withdrawtype * 1 === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type"
                         label="状态">
          <template slot-scope="scope">
          <span v-for="item in options.status"
                v-if="scope.row.type * 1 === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import { searchRules } from '../finance.rules'

export default {
  mixins: [table],
  data () {
    return {
      table: [],
      searchRules,
      multipleSelection: [],
      search: {
        userid: null,
        starttime: null,
        endtime: null,
        sort_by_userid: null,
        sort_by_balance: null,
        sort_by_frozenbalance: null,
        sort_by_totalwithdraw: null,
        withdrawtype: null,
      },
      dialogWithdrawTableVisible: false,
      batchDetailTable: [],
      isExportAll: false
    }
  },
  beforeRouteLeave (to, from, next) {
    // 离开时，清除当前页面设置的查询参数，避免在其他的提现页面保留这些查询参数
    Object.assign(this.$data, this.$options.data.call(this))
    next()
  },
  computed: Vuex.mapState({
    options: state => state.finance.options,
  }),
  created () {
    this.setWithdrawtype()
  },
  updated () {
    this.setWithdrawtype()
  },
  watch: {
  },
  methods: {
    getTableData (params) {
      return request.page('getWithdrawList', params)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    sortChange (column, prop, order) {
      let sortBy = 'asc'
      if (column.order === 'descending') {
        sortBy = 'desc'
      }
      if (column.prop === 'userid') {
        this.search.sort_by_userid = sortBy
      }
      if (column.prop === 'balance') {
        this.search.sort_by_balance = sortBy
      }
      if (column.prop === 'frozenbalance') {
        this.search.sort_by_frozenbalance = sortBy
      }
      if (column.prop === 'totalwithdraw') {
        this.search.sort_by_totalwithdraw = sortBy
      }

      this.onSearch()
    },

    onGenExcel () {
      let msg
      let multipleIds = this.multipleSelection.map(item => item.userid)
      if (this.isExportAll === false) {
        if (multipleIds.length === 0) {
          this.$message.error('请至少选择生成一个')
          return false
        }
        msg = '此操作将生成报表, 是否继续?'
      } else {
        let ids = []
        this.table.forEach((item) => {
          if (multipleIds.indexOf(item.userid) === -1) {
            ids.push(item.userid)
          }
        })
        multipleIds = ids
        msg = '此操作将所有提现请求生成报表, 是否继续?'
      }

      this.$confirm(msg, '提示', {type: 'warning'}).then(() => {
        request.common('withdrawGenExcel', {
          ...this.search,
          user_ids: multipleIds,
          is_export_all: this.isExportAll
        }).then(() => {
          this.$message.success('生成报表成功')
          this.onRefresh()
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },

    cancelWithdrawData (userid) {
      let params = {
        id: userid,
        withdrawtype: this.search.withdrawtype,
      }
      this.$confirm('此操作将驳回提现请求, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('cancelWithdraw', params).then(() => {
          this.$message.success('驳回提现请求成功')
          this.onSearch()
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },

    getWithdrawDetail (userid) {
      this.dialogWithdrawTableVisible = true
      let params = {
        id: userid,
        withdrawtype: this.search.withdrawtype,
      }
      request.common('withdrawDetail', params).then((data) => {
        let table = []
        data.data.forEach((row, index) => {
          table.push(row)
        })
        this.batchDetailTable = table
      })
    },

    setWithdrawtype () {
      if (this.$route.meta.title === '支付宝提现管理') {
        this.search.withdrawtype = 1
      } else if (this.$route.meta.title === '银行卡提现管理') {
        this.search.withdrawtype = 0
      } else if (this.$route.meta.title === '微信提现管理') {
        this.search.withdrawtype = 6
      }
    },

    batchCancelWithdraw () {
      let multipleIds = this.multipleSelection.map(item => item.userid)
      if (multipleIds.length === 0) {
        this.$message.error('请至少选择驳回一个')
        return false
      }
      this.$confirm('是否驳回已勾选的提现请求？', '提示', {type: 'warning'}).then(() => {
        const params = {
          user_ids: multipleIds,
          withdrawtype: this.search.withdrawtype,
        }
        request.loading('batchCancelWithdraw', params).then(() => {
          this.$message.success('批量驳回提现请求成功')
          this.onSearch()
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },

    setSelectAll (selection) {
      this.isExportAll = selection.length > 0
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/views/finance/pages/WithdrawTable.vue